import { useTranslation } from 'react-i18next'
import IconSVG from '@src/components/icons/search'
import Close from '@src/components/icons/close'
import { SearchIconWrap, SearchInput, SearchWrap } from './Search.styled'
import { ReactChildren, ReactPortal, useEffect, useState } from 'react'
import { useDebounce } from '@src/hooks/useDebounce'

interface SearchI {
  onChange: (e: any) => void
  initialTerm: string
  placeholder?: string
  width?: string
  height?: string
  children?: ReactPortal | ReactChildren | null
}

const Search = ({ onChange, initialTerm = '', width = '', height = '', placeholder, children }: SearchI) => {
  const { t } = useTranslation()
  const DEFAULT_PLACEHOLDER = t('globalSearchComponent.search', 'Search')
  const [searchTerm, setSearchTerm] = useState(initialTerm)

  const onChangeHandler = (e) => {
    setSearchTerm(e.target.value.toLowerCase())
  }

  const onCancelHandler = () => {
    onChange('')
  }

  const debouncedTerm = useDebounce(searchTerm, 200)

  useEffect(() => {
    onChange(debouncedTerm)
  }, [debouncedTerm])

  useEffect(() => {
    setSearchTerm(initialTerm)
  }, [initialTerm])

  return (
    <>
      <SearchWrap>
        <SearchInput
          $width={width}
          $height={height}
          onChange={onChangeHandler}
          placeholder={placeholder || DEFAULT_PLACEHOLDER}
          type="text"
          value={searchTerm}
          className="globalSearchInput"
        />
        <SearchIconWrap>
          {!searchTerm && <IconSVG />}
          {searchTerm && <Close onClick={onCancelHandler} />}
        </SearchIconWrap>
      </SearchWrap>
      {children}
    </>
  )
}

export default Search
